
/* styles */
require("!!vue-style-loader!css-loader!../node_modules/.11.3.4@vue-loader/lib/style-compiler/index?{\"id\":\"data-v-089b616f\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader!../node_modules/.11.3.4@vue-loader/lib/selector?type=styles&index=0!./App.vue")

var Component = require("!../node_modules/.11.3.4@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/.11.3.4@vue-loader/lib/selector?type=script&index=0!./App.vue"),
  /* template */
  require("!!../node_modules/.11.3.4@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-089b616f\"}!../node_modules/.11.3.4@vue-loader/lib/selector?type=template&index=0!./App.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/App.vue
// module id = 23
// module chunks = 0